const MIN_SEEK = 10;
const MAX_SEEK = 40;
const SEEK_PERCENT = 5;

const calculateSeek = (duration: number) => {
  return Math.min(Math.max((duration / 100) * SEEK_PERCENT, MIN_SEEK), MAX_SEEK);
};

export default calculateSeek;
